import * as React from 'react';

type Generator<T> = (row: T) => React.ReactNode;

export function composeMultipleCells<T>(generators: Generator<T>[]): Generator<T> {
  return (input: T) => {
    return (
      <React.Fragment>
        {generators.map((generator, index) => (
          <React.Fragment key={index}>{generator(input)}</React.Fragment>
        ))}
      </React.Fragment>
    );
  };
}
